import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../customCheckbox';
import Textinput from '../textinput';
import TableCell from './tableCell';

import { NotificationType } from '../../constants/notifications';

const isChecked = (ids, id) => !!(ids && ids.find(item => +item === +id));

const isAllSelected = (ids, selectedIds) =>
    ids && ids.filter(id => !selectedIds.includes(id)).length === 0 && ids.length > 0;

const TableRow = ({
    user,
    cellWidth,
    userType,
    productsIds,
    isApprovedCompany,
    deleteUser,
    setNotification,
    unsetNotification,
}) => {
    const isNonUsers = userType === 'nonusers';
    const isAllPushSelected = !isNonUsers ? isAllSelected(productsIds, user.push_whitelist) : false;
    const isAllEmailSelected = isAllSelected(productsIds, user.email_whitelist);

    const onChange = useCallback((product_ids, type, isActive, isShowConfirmation = false) => {
        const params = { product_ids, type };
        if (userType === 'nonusers') {
            params.email = user.email;
            params.entity_id = user.entity_id;
        } else {
            params.user_id = user.user_id;
        }

        return isActive
            ? unsetNotification(userType, params, isShowConfirmation)
            : setNotification(userType, params, isShowConfirmation);
    }, []);

    return (
        <div
            className="row"
            key={`email_${user.email}_${user.user_id}`}
            title={!isApprovedCompany ? 'The company is blocked' : ''}
        >
            <div className="mn-label-holder">
                <div className="input-holder">
                    <Textinput
                        readOnly
                        label=""
                        name="email"
                        buttonPadding={isNonUsers}
                        value={user.email}
                        onChange={() => ''}
                        type="email"
                    />
                    {isNonUsers ? (
                        <div className="sq-button sq-button-delete" onClick={() => deleteUser(user.entity_id)} />
                    ) : null}
                </div>
            </div>
            <div className="mn-cells-holder">
                {productsIds && productsIds.length ? (
                    <React.Fragment>
                        <TableCell width={cellWidth} isSingleRow={isNonUsers}>
                            <Checkbox
                                color="blue"
                                readOnly={!isApprovedCompany}
                                checked={isAllEmailSelected}
                                onChange={() => onChange(productsIds, NotificationType.EMAIL, isAllEmailSelected, true)}
                            />
                            {!isNonUsers ? (
                                <Checkbox
                                    color="green"
                                    readOnly={!isApprovedCompany}
                                    checked={isAllPushSelected}
                                    onChange={() =>
                                        onChange(productsIds, NotificationType.PUSH, isAllPushSelected, true)
                                    }
                                />
                            ) : null}
                        </TableCell>
                        {productsIds.map(productId => {
                            const emailChecked = isChecked(user.email_whitelist, productId);
                            const pushChecked = !isNonUsers ? isChecked(user.push_whitelist, productId) : false;

                            return (
                                <TableCell width={cellWidth} isSingleRow={isNonUsers} key={`prodVal${productId}`}>
                                    <Checkbox
                                        color="blue"
                                        readOnly={!isApprovedCompany}
                                        checked={emailChecked}
                                        onChange={() => onChange([productId], NotificationType.EMAIL, emailChecked)}
                                    />
                                    {!isNonUsers ? (
                                        <Checkbox
                                            color="green"
                                            readOnly={!isApprovedCompany}
                                            checked={pushChecked}
                                            onChange={() => onChange([productId], NotificationType.PUSH, pushChecked)}
                                        />
                                    ) : null}
                                </TableCell>
                            );
                        })}
                    </React.Fragment>
                ) : (
                    'No products'
                )}
            </div>
        </div>
    );
};

TableRow.propTypes = {
    user: PropTypes.shape({
        email: PropTypes.string,
        user_id: PropTypes.number,
        entity_id: PropTypes.number,
        email_whitelist: PropTypes.arrayOf(PropTypes.number),
        push_whitelist: PropTypes.arrayOf(PropTypes.number),
    }).isRequired,
    cellWidth: PropTypes.shape({}).isRequired,
    userType: PropTypes.string.isRequired,
    productsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    isApprovedCompany: PropTypes.bool.isRequired,
    deleteUser: PropTypes.func.isRequired,
    setNotification: PropTypes.func.isRequired,
    unsetNotification: PropTypes.func.isRequired,
};

export default React.memo(TableRow);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/tableRow.js